import { useState } from "react";
import DevNavbar from "./components/DevNavbar";
import DevHero from "./components/DevHero";
import DevAbout from "./components/DevAbout";
import DevSkills from "./components/DevSkills";
import DevProjects from "./components/DevProjects";
import DevEducation from "./components/DevEducation";
import DevContact from "./components/DevContact";
import DevFooter from "./components/DevFooter";
import PageLoader from "./components/PageLoader";
import ScrollProgress from "./components/ScrollProgress";
import DevServices from "./components/DevService";

export default function HomePage() {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && <PageLoader onDone={() => setLoaded(true)} />}
      <div
        className={`relative w-full min-h-screen transition-opacity duration-700 ${loaded ? "opacity-100" : "opacity-0"}`}
      >
        <DevNavbar />
        <DevHero />
        <DevAbout />
        <DevServices />
        <DevProjects />
        <DevSkills />
        <DevEducation />
        <DevContact />
        <DevFooter />
      </div>
    </>
  );
}
